import PropTypes from "prop-types";
import React from "react";
import TextStyles from "theme/components/text/TextStyles";
import styled from "theme/libs/styled";

const StyledBadge = styled("div")`
    display: flex;
    align-items: center;
    padding: 4px 8px 5px;
    border-radius: 100px;

    ${({ theme }) => theme.above.tabletLg} {
        padding: 6px 12px;
    }
`;

const Badge = ({ children, text, textStyle, ...restProps }) => {
    return (
        <StyledBadge {...restProps}>
            <TextStyles as="span" textStyles={textStyle}>
                {text}
            </TextStyles>
            {children}
        </StyledBadge>
    );
};

Badge.propTypes = {
    children: PropTypes.node,
    text: PropTypes.string.isRequired,
    textStyle: PropTypes.string,
    to: PropTypes.string,
};

Badge.defaultProps = {
    children: [],
    textStyle: "Buenos Aires/12-120 Regular",
    to: null,
};

export default Badge;
